/**
 * 取引先売上品目単価
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/suppliers`
const search_emission_sales_item_price = {
  namespaced: true,
  actions: {
    /**
     *
     * @param dispatch
     * @param commit
     * @param state
     * @param id
     * @param type
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { id, type, only_jwnet_item }) {
      const params = { type: type, only_jwnet_item: only_jwnet_item }
      const api_path = `${API_PATH}/${id}/sales_item_price_details`
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    index_with_reference_date ({ dispatch, commit, state }, { id, type, only_jwnet_item, reference_date }) {
      const params = { type: type, only_jwnet_item: only_jwnet_item, reference_date: reference_date }
      const api_path = `${API_PATH}/${id}/sales_item_price_details`
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },

  },
  mutations: {},
}

export default search_emission_sales_item_price

